import { memo } from 'react';
import { TooltipProvider as ShadcnTooltipProvider } from '@/components/_shadcn-ui/tooltip';

interface ITooltipProviderProps {
  children: React.ReactNode;
}

const TooltipProvider = memo(({ children }: ITooltipProviderProps) => {
  return <ShadcnTooltipProvider delayDuration={0}>{children}</ShadcnTooltipProvider>;
});

TooltipProvider.displayName = 'TooltipProvider';

export default TooltipProvider;
